import { render, staticRenderFns } from "./transprotContentManage.vue?vue&type=template&id=6bc35e06&scoped=true"
import script from "./transprotContentManage.vue?vue&type=script&lang=js"
export * from "./transprotContentManage.vue?vue&type=script&lang=js"
import style0 from "./transprotContentManage.vue?vue&type=style&index=0&id=6bc35e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc35e06",
  null
  
)

export default component.exports